import React, {ReactElement, useMemo} from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import {Typography} from '@customink/pigment-react';
import {CardActionArea} from '@mui/material';
import ProductColorSwatch from '../ProductColorSwatch';
import {StoreProductWithColors} from '../StoreProductsListing/ProductList';
import Price from './Price';
import services from '../../api/remoteServices';
import './index.scss';

type ProductCardProps = {
  storeSlug: string;
  product: StoreProductWithColors;
  handleSelect: (productId: number, colorId: number) => void;
  donationItem?: boolean;
};

// PENDING: [Phelan Lucky] temporarily hard-coded, remove once fundraiser is over
const url = (storeSlug: string, productId: StoreProductWithColors['id']) =>
  `${
    services[storeSlug === 'phelan-lucky' ? 'stores' : 'storefront']
  }/${storeSlug}/products/${productId}`;

const ProductListingCard: React.FC<ProductCardProps> = ({
  storeSlug,
  product,
  handleSelect,
  donationItem
}: ProductCardProps): ReactElement => {
  const displayOnly = product?.colors.length === 1;
  const storeDetaillUrl = useMemo(() => {
    return url(storeSlug, product.id);
  }, [product]);

  return (
    <Card className="productCard">
      <CardContent className="productCard-content-image">
        {/* possible change to react router dom link after detail page available */}
        <CardActionArea href={storeDetaillUrl}>
          <CardMedia
            className="productCard-image"
            component="img"
            image={product.mainImage}
            alt={product.name}
          />
        </CardActionArea>
      </CardContent>
      <div className="stores-productCard-details">
        <CardContent className="productInfo">
          <Typography className="productCard-name">{product.name}</Typography>
          <Price
            price={product?.price}
            originalPrice={product?.originalPrice}
            className="stores-productCard-price"
            skipFormatting={donationItem}
          />
        </CardContent>
        {product.colors.map(c => {
          return (
            <ProductColorSwatch
              key={c.id}
              rgb={c.rgbs[0]}
              productId={product.id}
              trimRgb={c.trim_rgb}
              colorName={c.name}
              colorId={c.id}
              displayOnly={displayOnly}
              handleSelect={handleSelect}
            />
          );
        })}
        {!product.colors && (
          <Skeleton variant="rectangular" width={27} height={27} />
        )}
      </div>
    </Card>
  );
};

ProductListingCard.defaultProps = {
  donationItem: false
};

export default ProductListingCard;
